"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _styles = require("./styles");
var _Popover = _interopRequireDefault(require("./Popover"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FilterButton = _ref => {
  let {
    active,
    btnAriaLabel,
    btnText,
    children,
    dataTestId,
    popoverDirection,
    onOpen
  } = _ref;
  const buttonContainerRef = (0, _react.useRef)(null);
  const [showPopover, setShowPopover] = (0, _react.useState)(false);
  const handleClick = () => {
    if (!showPopover) {
      onOpen();
    }
    setShowPopover(!showPopover);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.FilterButtonContainer, {
    ref: buttonContainerRef
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: handleClick,
    "aria-label": btnAriaLabel,
    mode: active ? 'primary' : undefined,
    "data-testid": dataTestId
  }, btnText), showPopover && /*#__PURE__*/_react.default.createElement(_Popover.default, {
    buttonRef: buttonContainerRef,
    open: showPopover,
    onClose: handleClick,
    direction: popoverDirection,
    dataTestId: `${dataTestId}-popover`
  }, children));
};
FilterButton.propTypes = {
  active: _propTypes.bool,
  btnText: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]).isRequired,
  btnAriaLabel: _propTypes.string,
  children: _propTypes.node.isRequired,
  dataTestId: _propTypes.string,
  popoverDirection: (0, _propTypes.oneOf)(['right', 'left']),
  onOpen: _propTypes.func
};
var _default = exports.default = FilterButton;
FilterButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FilterButton",
  "props": {
    "active": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "btnText": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": true
    },
    "btnAriaLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "dataTestId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "popoverDirection": {
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }]
      },
      "required": false
    },
    "onOpen": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};